module.exports = __webpack_public_path__ + "media/Images/icon-calendar-o-6dd1069519360b1fa4d3aab1744015f5.svg";